import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import FieldLabel from "../../../components/Fields/FieldLabel";
import ItemSizeModel from "../../../models/ItemSizeModel";
import ItemRevision_popup_AddSize from "../Popups/ItemRevision_popup_AddSize";
import ItemSizeControl from "./ItemRevisionSizeControl";

interface IProps {
    onAdd: (sizes: ItemSizeModel[]) => void
    onShowEditPopup: () => void
    itemSizes: ItemSizeModel[]
    itemId: number
    itemRevisionId: number
}

const ItemRevisionSizeField: React.FC<IProps> = ({ onAdd, onShowEditPopup, itemSizes, itemId, itemRevisionId  }) => {
    const [showAddPopup, setShowAddPopup] = useState(false)
    const [itemRevisionSizes, setItemRevisionSizes] = useState(itemSizes)

    useEffect(() => {
        setItemRevisionSizes(itemSizes)
    }, [itemSizes])

    var labelSize = 2

    function hidePopup(addedItemSizes?: ItemSizeModel[]) {
        setShowAddPopup(false)
        if (addedItemSizes)
            onAdd(addedItemSizes)
    }

    return (
        <>
            <Form.Group as={Row} className="form-field">
                <FieldLabel text={'Sizes'} required={false} labelSize={labelSize} style={{ lineHeight: '22px' }} />
                <Col sm={12 - labelSize} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    {itemRevisionSizes.map(size => <ItemSizeControl itemSize={size} onShowEditPopup={onShowEditPopup} key={size.concurrencyId} />)}
                    <div className='item-color' onClick={() => setShowAddPopup(true)}>+</div>
                </Col>
            </Form.Group>
            {showAddPopup && <ItemRevision_popup_AddSize show={showAddPopup} onHide={hidePopup} itemId={itemId} itemRevisionId={itemRevisionId} />}
        </>
    );
}
export default ItemRevisionSizeField;